import React, { useState } from 'react';
import { portfolioGallery, portfolioCategories } from '../data/mock';

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [hoveredItem, setHoveredItem] = useState(null);

  const filteredGallery = activeCategory === 'all'
    ? portfolioGallery
    : portfolioGallery.filter(item => item.category.includes(activeCategory));

  return (
    <section id="portfolio" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
            Portfolio Kami
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 40px' }}>
            Koleksi pernikahan indah yang telah kami wujudkan dengan sempurna
          </p>

          {/* Category Filter */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            justifyContent: 'center',
            marginTop: '40px'
          }}>
            {portfolioCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className="button-text"
                style={{
                  padding: '12px 24px',
                  background: activeCategory === category.id ? 'var(--interactive-base)' : 'transparent',
                  color: activeCategory === category.id ? 'var(--bg-primary)' : 'var(--text-primary)',
                  border: `1px solid ${activeCategory === category.id ? 'var(--interactive-base)' : 'var(--border-medium)'}`,
                  borderRadius: '0px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontSize: '14px',
                  fontWeight: activeCategory === category.id ? '700' : '400'
                }}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '24px'
        }}>
          {filteredGallery.map((item) => (
            <div
              key={item.id}
              className="product-card"
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              style={{
                position: 'relative',
                overflow: 'hidden',
                cursor: 'pointer',
                background: 'var(--bg-secondary)'
              }}
            >
              <div style={{ position: 'relative', overflow: 'hidden', height: '350px' }}>
                <img
                  src={item.image}
                  alt={item.alt}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.5s ease',
                    transform: hoveredItem === item.id ? 'scale(1.05)' : 'scale(1)'
                  }}
                />
                {/* Overlay on hover */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(0,0,0,0.5)',
                  opacity: hoveredItem === item.id ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <h3 className="heading-3" style={{ color: '#ffffff', textAlign: 'center', padding: '0 20px' }}>
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
